import { React, useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import { SimpleSelect } from "../../ConfigurarLeads/SimpleSelect";

const TIPO_SALA_OPCIONES = [
    { value: "N", label: "Normal" },
    { value: "A", label: "Autorizado" },
];

const ESTADO_OPCIONES = [
    { value: "true", label: "Activo" },
    { value: "false", label: "Inactivo" },
];

const camposIniciales = {
    idsala: -999,
    nombresala: "",
    tiposala: "N",
    estado: true,
    usuario: 1,
};

// Modal único para Alta y Edición de Cat_Sala.
export const SalaModal = ({ open, onClose, editId = null, onSaved }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [form, setForm] = useState(camposIniciales);

    const esEdicion = !!editId;

    useEffect(() => {
        if (!open) return;

        if (!editId) {
            setForm(camposIniciales);
            return;
        }

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get(`Sala/Obtener/${editId}`)
            .then((result) => {
                setForm({ ...result, usuario: 1 });
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("SALAS", "No se pudo cargar la sala", "error");
            });
    }, [open, editId]);

    const validar = () => {
        if (!form.nombresala || !form.nombresala.trim()) {
            Swal.fire("SALAS", "El nombre es obligatorio", "warning");
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader((prev) => ({ ...prev, mostrar: true }));

        request
            .post("Sala/Guardar", form)
            .then(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "SALAS",
                    esEdicion ? "Sala actualizada correctamente" : "Sala guardada correctamente",
                    "success"
                );
                onSaved && onSaved();
                handleCancelar();
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("ERROR", "No se pudo guardar la sala", "error");
            });
    };

    const handleCancelar = () => {
        setForm(camposIniciales);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="sala-modal-formulario">
                <div className="sala-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="sala-modal">
                        <PlantillaScreen
                            titulo={esEdicion ? "EDITAR SALA" : "NUEVA SALA"}
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="sala-modal-content">
                                <div className="sala-modal-content-container scroll-4">
                                    <div className="lead-form-group">
                                        <label>Nombre de la sala</label>
                                        <input
                                            type="text"
                                            value={form.nombresala}
                                            onChange={(e) => setForm((prev) => ({ ...prev, nombresala: e.target.value }))}
                                            maxLength={30}
                                            placeholder="Ej. Sala de juntas 1"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Tipo de sala</label>
                                        <SimpleSelect
                                            options={TIPO_SALA_OPCIONES}
                                            value={form.tiposala}
                                            onChange={(val) => setForm((prev) => ({ ...prev, tiposala: val }))}
                                            placeholder="Seleccione el tipo"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Estado</label>
                                        <SimpleSelect
                                            options={ESTADO_OPCIONES}
                                            value={form.estado ? "true" : "false"}
                                            onChange={(val) => setForm((prev) => ({ ...prev, estado: val === "true" }))}
                                            placeholder="Seleccione el estado"
                                        />
                                    </div>
                                </div>
                                <div className="sala-modal-buttons">
                                    <button
                                        className="sala-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="sala-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SalaModal;
